import { Grid } from '@material-ui/core'
import { FunctionComponent } from 'react'
import { MdClear } from 'react-icons/md'

import { colors } from '../../styles/colors'
import Button from '../Button'
import LoadingBackdrop from '../LoadingBackdrop'
import { IScaffoldProps } from './ScaffoldComponent.types'
import { Box, Container, Content, Header, Title } from './styles'

const Scaffold: FunctionComponent<IScaffoldProps> = ({
  children,
  onClickBackButton,
  onClickNextButton,
  onClickExcludeButton,
  titleBackButton,
  titleNextButton,
  isNextButtonDisabled,
  color,
  title,
  titleHeader,
  icon: Icon,
  showFooterScaffold = true,
  loading,
}) => (
  <>
    <Box>
      {showFooterScaffold && (
        <Header>
          <Grid container>
            <Grid item md={3}>
              {titleHeader && <Title>{titleHeader}</Title>}
            </Grid>
          </Grid>

          {onClickBackButton && (
            <Button
              color={colors.white}
              style={{
                marginRight: 10,
                color: colors.gray,
                border: '1px solid',
              }}
              onClick={onClickBackButton}
            >
              {titleBackButton}
            </Button>
          )}

          {onClickExcludeButton && (
            <Button
              color={colors.red}
              style={{
                marginRight: 10,
                color: colors.white,
                border: '1px solid',
              }}
              onClick={onClickExcludeButton}
            >
              <MdClear /> Excluir
            </Button>
          )}

          {onClickNextButton && (
            <Button
              color={
                color ?? `${isNextButtonDisabled ? colors.gray : colors.green}`
              }
              onClick={onClickNextButton}
              disabled={isNextButtonDisabled}
            >
              {Icon && (
                <Icon
                  style={{ color: 'white', fill: 'white' }}
                  color={colors.white}
                />
              )}{' '}
              {titleNextButton}
            </Button>
          )}
        </Header>
      )}
    </Box>

    <Container>
      <Content>
        {title && <Title style={{ fontStyle: 'italic' }}>{title}</Title>}
        {children}
      </Content>
      <LoadingBackdrop open={loading} color={colors.green} />
    </Container>
  </>
)

export default Scaffold
